import React, { useEffect } from 'react';
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  clearAll,
  onOnboardUser,
  setErrorMessage,
  setLoading
} from "../../../config/redux/slice/authSlice";
import { postRequest } from '../../../helpers/request';
import { appApi } from '../../../utils/endpoints/appApi';
import { appUrls } from '../../../utils/urls/appUrls';
import { AuthAlert, Spinner } from '../../components';
import AuthFormWrapper from '../../layout/AuthFormWrapper';

export default function ForgotPassword() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {register, handleSubmit, formState: {errors}} = useForm({mode: 'onTouched'})

    const {
            loading,
            errorMsg,
        } = useSelector((state) => state.authData)

    useEffect(()=>{
      dispatch(clearAll({}))
    }, [])    

    const onSubmit = async (data) => {
        dispatch(clearAll({}))
        const res = await postRequest(
            "",
            `${appApi.forgot_password}`,
            data,
            dispatch,
            setLoading,
            "",
            setErrorMessage
        )
        if(res !== undefined && res.status < 400){
          dispatch(onOnboardUser({email: data.email}))
          navigate(appUrls.passwordLinkSuccess)
        }
    }

    const closeAlert = () => {
        dispatch(setErrorMessage({message: null}))
    }

  return (
    <AuthFormWrapper sub_text='Enter your email to retrieve password' onHandleSubmit={handleSubmit(onSubmit)}>
        {errorMsg && <AuthAlert onClick={closeAlert} alertStyles={{width: '95%', margin: '0 auto'}} status='error'>
            {errorMsg}
        </AuthAlert>}
      <div className="form-group col-md-12 mb-4">
        <label htmlFor='email'>Email</label>
        <input 
          type="email" 
          className="form-control input-lg" 
          id="email" 
          aria-describedby="emailHelp"
          {...register("email", {
            required: {
              value: true,
              message: '*this field is required'
            },
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: '*invalid email pattern'
            }
          })
          }
        />
        {
          errors?.email?.message &&
          <div className="text-danger small mt-1">
            {errors?.email?.message}
          </div>
        }
      </div>
      <div className="col-md-12">

        <div>
          {loading ? 
            <Spinner/> :
            <button type="submit" className="btn btn-primary mb-4">Reset</button>
          }
        </div>

        <p>
          <Link className="text-blue" to={appUrls.login}>Back to Login</Link>
          {/* <a className="text-blue" href="sign-up.html">Register Here</a> */}
        </p>
      </div>
    </AuthFormWrapper>
  )
}
